// @flow

import React, { type Node } from 'react';

import { IfFeature } from '@tectonics/prs/feature';
import { useAllFeatures } from '@tectonics/prs/payment-spec';

import { TipsBox } from '@tectonics/look-and-feel/uber-v2/organisms';

import copyPasteTipSrc from './tip-copy-paste.svg';
import smartphoneConfirmationTipSrc from './tip-smartphone-confirmation.svg';

export function PixTips(): Node {
  const allFeatures = useAllFeatures();

  return (
    <IfFeature allFeatures={allFeatures} wanted="display_pix_tips_box">
      <TipsBox
        title="Como pagar?"
        tipsModel={[
          {
            imgSrc: copyPasteTipSrc,
            altText: 'copy paste icon',
            tipText: 'Cole o código Pix em seu app bancário ou carteira digital de preferência e confirme o pagamento.',
          },
          {
            imgSrc: smartphoneConfirmationTipSrc,
            altText: 'phone confirmation icon',
            tipText: 'Seu pagamento será aprovado em alguns instantes.',
          },
        ]}
      />
    </IfFeature>
  );
}
